// extracted by mini-css-extract-plugin
export default {"organizationChip":"InviteUser_organizationChip__ncZ0N"};